import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {WMSContext} from "../../../../../../context/WMSContext";
import BottomDrawer from "../../../../../../../../components/WMS/Mobile/BottomDrawer";
import {Grid} from "@mui/material";
import CustomButton from "../../../../../../../../components/CustomButton";
import Index from "../../../../../../../picking/printers";
import organization from "../../../../../../../../reducers/organization";
import {Authorizations, hasAuthorization} from "../../../../../../../../utils/authorizations";
import {red500} from "../../../../../../../../assets/jss/main";
import {FormattedMessage} from "react-intl";
import {patchWmsContainersWithCodebar} from "../../../../../../../../api/wms/wmsContainers/wmsContainers";

PrinterConfigurationDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

function PrinterConfigurationDrawer({open, onClose}) {
    const {currentOrganization, currentMemberAuthorizations, isMobile, preferredPackingStation} = useContext(WMSContext)

    const handleSave = ({labelPrinterId}) => {
        if (preferredPackingStation?.codebar && labelPrinterId) {
            patchWmsContainersWithCodebar(preferredPackingStation.codebar, {labelPrinterId})
        }
    }

    if (!hasAuthorization(currentMemberAuthorizations, Authorizations.PICKING_PRINTERS)) {
        return (
            <BottomDrawer
                open={open}
                onClose={onClose}
                openMaxHeight
                noHeightLimit
            >
                <Grid sx={{height: "100%"}} container justifyContent={"center"} alignContent={"center"}>
                    <span style={{color: red500}}><FormattedMessage id={"wms.printers.noAuthorization"}/></span>
                </Grid>
            </BottomDrawer>
        )
    }

    return (
        <BottomDrawer
            open={open}
            onClose={onClose}
            openMaxHeight
            noHeightLimit
        >
            <Grid
                container
                justifyContent={"space-between"}
                direction={"column"}
                alignContent={"center"}
                sx={{padding: "8px"}}
            >
                <Index noSideBarDesktop={!isMobile} isEmbedded={true} handleIsEmbedded={onClose} organization={currentOrganization} authorizations={currentMemberAuthorizations} onSave={handleSave} />
            </Grid>
        </BottomDrawer>
    );
}

export default PrinterConfigurationDrawer;